





























































































































import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import {} from "googlemaps";
import gmapsStyle from "./gmaps-style.json";
import { initalizeGoogleMaps } from "@/services/maps/index";
import Geometry from "ol/geom/Geometry";
import Polygon from "ol/geom/Polygon";
import AgroFileUpload from "@/components/agroFileUpload/AgroFileUpload.vue";
import * as carPointApi from "@/api/car/index";
import CarSelectModal from "@/views/farms/components/car-select-modal/CarSelectModal.vue";
import { CarDTO, CarNearDTO, RuralInfo } from "@/api/car/types";
import * as notificationService from "@/services/notification/index";
import i18n from "@/i18n";
import { LocationPayload } from "./types";
import Loading from '@/components/loading/Loading.vue';
import { wrapGeometryObject } from "@/helpers/geojson";
import { plainToClass } from "class-transformer";

@Component({
  name: "WrappedGmMap",
  components: {
    AgroIcon: AgroIcons,
    FileUpload: AgroFileUpload,
    CarSelectModal,
    Loading,
  },
})
export default class WrappedGmMap extends Vue {
  /* A google maps implementation */
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: String, default: "base-style" })
  private mapClass!: string;
  @Prop(Object)
  private polygon: Geometry | null = null;

  @Prop({ type: Object, default: () => ({
      lat: -14.8406317,
      lng: -50.6837379,
      zoom: 4,
    }),
  })
  private startLocation!: LocationPayload;
  private wrappedMap: google.maps.Map<Element> | null = null;
  private searchWidget: google.maps.places.Autocomplete | null = null;
  private drawingManager: google.maps.drawing.DrawingManager | null = null;
  private drawingOverlay: google.maps.Polygon | null = null;
  private listeners: google.maps.MapsEventListener[] = [];
  private coordinatesString: string = "";
  private canClear: boolean = false;
  private readyToShow = false;
  private copyPastVisible = false;
  private geoUpload2: File | null = null;
  private isLoading: boolean | null = null;
  private response: any | undefined = undefined;
  private isFileUploadVisible: boolean = false;
  private carResponse: CarDTO | null = null;
  private carResponseList: RuralInfo[] = [];
  private isCarSelectVisible: boolean = false;
  private carsNear: Array<google.maps.Data.Feature> = [];
  private carsNearInfo: google.maps.InfoWindow | null = null;// = new google.maps.InfoWindow();
  private mapDataEventListeners: Array<google.maps.MapsEventListener> = [];
  private toggleCarsNear: boolean = false;

  private get mapStyle() {
    const style = [this.mapClass];
    if (this.disabled) {
      style.push("is-disabled");
    }
    return style;
  }
  private mounted() {
    requestAnimationFrame(async () => {
      await initalizeGoogleMaps(this.initMap);
    });
  }

  private initMap() {
    const mapOptions: google.maps.MapOptions = {
      center: {
        lat: this.startLocation.lat,
        lng: this.startLocation.lng,
      },
      zoom: this.startLocation.zoom,
      zoomControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      mapTypeId: "hybrid",
      styles: gmapsStyle as google.maps.MapTypeStyle[],
    };

    this.wrappedMap = new window.google.maps.Map(
      this.$refs.mapElement as Element,
      mapOptions
    );

    requestAnimationFrame(() => {
      this.searchWidget = this.initSearch(
        this.$refs.searchInputControl as HTMLElement,
        this.$refs.searchInput as HTMLInputElement
      );
    });

    requestAnimationFrame(() => {
      this.drawingManager = this.initDrawing();
    });

    requestAnimationFrame(() => {
      window.google.maps.event.addListenerOnce(
        this.wrappedMap!,
        "tilesloaded",
        () => {
          this.readyToShow = true;
        }
      );
      this.initCoordinatesLabel(this.$refs.coordinateLabel as HTMLElement);
    });

    this.carsNearInfo = new google.maps.InfoWindow();

    if (this.wrappedMap) {
      this.removeCarsNear();
      this.carsNear = [];
    }
  }

  @Watch('startLocation') 
  private onChangeLocation(startLocation: LocationPayload){
      this.wrappedMap?.setCenter({
        lat: startLocation.lat,
        lng: startLocation.lng,
      })
      this.wrappedMap?.setZoom(startLocation.zoom)
  }

  private initSearch(
    containerElement: HTMLElement,
    inputElement: HTMLInputElement
  ) {
    this.placeControl(
      containerElement,
      window.google.maps.ControlPosition.TOP_LEFT
    );
    const options = {
      fields: ["address_component", "name", "geometry"],
    };
    const widget = new window.google.maps.places.Autocomplete(
      inputElement,
      options
    );

    this.registerListener(
      widget.addListener("place_changed", () => {
        const place = widget.getPlace();
        this.panToPlace(place);
      })
    );

    return widget;
  }

  private initCoordinatesLabel(element: HTMLElement) {
    this.placeControl(element, window.google.maps.ControlPosition.RIGHT_BOTTOM);
    this.registerListener(
      this.wrappedMap!.addListener("mousemove", (event) => {
        this.displayCoordinates(event.latLng);
      })
    );
  }

  private initDrawing() {
    const drawingOptions: google.maps.drawing.DrawingManagerOptions = {
      drawingControl: false,
      polygonOptions: {
        fillColor: "#0000f2",
        fillOpacity: 0.2,
        strokeColor: "#fff",
        strokeWeight: 5,
        clickable: false,
        editable: false,
        zIndex: 1,
      },
    };

    const drawingManager = new window.google.maps.drawing.DrawingManager(
      drawingOptions
    );
    this.placeControl(
      this.$refs.mapControls as HTMLElement,
      window.google.maps.ControlPosition.RIGHT_TOP
    );

    drawingManager.setMap(this.wrappedMap);

    this.registerListener(
      window.google.maps.event.addListener(
        drawingManager,
        "polygoncomplete",
        (polygon: google.maps.Polygon) => {
          // This validation is necessary to check if the drawing was finished
          if (drawingManager.getDrawingMode() === "polygon") {
            drawingManager.setDrawingMode(null);
            drawingManager.setOptions({
              drawingControl: false,
            });
            this.drawingOverlay = polygon;
            this.canClear = true;
            this.$emit(
              "geojson-text:ready",
              this.convertToGeojsonText(polygon)
            );
          } else {
            polygon.setMap(null);
          }
        }
      )
    );

    this.registerListener(
      window.google.maps.event.addListener(
        drawingManager,
        "markercomplete",
        async (marker: google.maps.Marker) => {
          // This validation is necessary to check if the drawing was finished
          if (drawingManager.getDrawingMode() === "marker") {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            await this.getFarmByCentroid(marker.getPosition()!);
          }
          marker.setMap(null);
        }
      )
    );
    return drawingManager;
  }

  private registerListener(listener: google.maps.MapsEventListener) {
    this.listeners.push(listener);
  }

  private unregisterListeners() {
    this.listeners.forEach((listener) => {
      window.google.maps.event.removeListener(listener);
    });
  }

  private panToPlace(place: google.maps.places.PlaceResult) {
    if (place.geometry) {
      if (place.geometry.viewport) {
        this.wrappedMap!.fitBounds(place.geometry.viewport);
      } else {
        this.wrappedMap!.setCenter(place.geometry.location);
        this.wrappedMap!.setZoom(17);
      }
    }
  }

  private placeControl(
    element: HTMLElement,
    position: google.maps.ControlPosition
  ) {
    this.wrappedMap!.controls[position].push(element);
  }

  private displayCoordinates(pnt: google.maps.LatLng) {
    const lat = pnt.lat().toFixed(4);
    const lng = pnt.lng().toFixed(4);
    this.coordinatesString = this.$t("core.wrapped-gm.latLngLabel", {
      lat,
      lng,
    }) as string;
  }

  private startDrawing() {
    if (this.drawingManager) {
      this.canClear = true;
      this.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.POLYGON
      );

      this.closeGeojsonTextbox();
    }

    this.closeNearCarsInfo();
  }

  private startCopyPast() {
    this.$emit("showPastOptions");
    this.copyPastVisible = !this.copyPastVisible;
    this.closeNearCarsInfo();
  }

  private closeGeojsonTextbox() {
    if (this.copyPastVisible) {
      this.startCopyPast();
    }
  }

  private clearDrawing() {
    if (this.drawingManager) {
      this.canClear = false;
      this.copyPastVisible = false;
      this.clearPolygon();
      this.drawingManager.setDrawingMode(null);
      this.$emit("geojson-text:clear");
    }
  }

  private zoomIn() {
    if (!!this.wrappedMap) {
      this.wrappedMap.setZoom(this.wrappedMap.getZoom() + 1);
    }
    this.closeNearCarsInfo();
  }

  private zoomOut() {
    if (!!this.wrappedMap) {
      this.wrappedMap.setZoom(this.wrappedMap.getZoom() + -1);
    }
    this.closeNearCarsInfo();
  }

  private clearPolygon() {
    if (this.drawingOverlay) {
      this.drawingOverlay.setMap(null);
      this.drawingOverlay = null;
    }
  }

  private convertToGeojsonText(polygon: google.maps.Polygon) {
    if (polygon) {
      const coordinates = [];
      for (let i = 0; i < polygon.getPath().getLength(); i += 1) {
        const pt = polygon.getPath().getAt(i);
        coordinates.push([pt.lng(), pt.lat()]);
      }
      coordinates.push(coordinates[0].map((x) => x));
      const geometryObject = {
        type: "Polygon",
        coordinates: [coordinates],
      };

      return JSON.stringify(geometryObject);
    }
    return "";
  }

  private beforeDestroy() {
    this.unregisterListeners();
    this.closeNearCarsInfo();
    this.removeCarsNear();
  }

  @Watch("drawingOverlayFromPolygon")
  private verifyDrawing(polygonOverlay: google.maps.Polygon | null) {
    if (this.wrappedMap && this.drawingManager && polygonOverlay) {
      this.drawingManager.setDrawingMode(null);
      this.drawingManager.setOptions({
        drawingControl: false,
      });
      if (!!this.drawingOverlay) {
        this.drawingOverlay.setMap(null);
      }
      this.drawingOverlay = polygonOverlay;
      polygonOverlay.setMap(this.wrappedMap);

      const bounds = new google.maps.LatLngBounds();
      polygonOverlay.getPath().forEach((element, index) => {
        bounds.extend(element);
      });
      this.wrappedMap!.fitBounds(bounds);
      this.canClear = true;
    }
  }

  /* tslint:disable:prefer-for-of */
  private get drawingOverlayFromPolygon() {
    if (this.polygon) {
      const opts = {} as google.maps.PolygonOptions;

      const geojson = this.polygon as Polygon;

      const paths = new google.maps.MVCArray<
        google.maps.MVCArray<google.maps.LatLng>
      >();

      for (let i = 0; i < geojson.getCoordinates().length; i++) {
        const path = new google.maps.MVCArray<google.maps.LatLng>();
        for (let j = 0; j < geojson.getCoordinates()[i].length; j++) {
          const ll = new google.maps.LatLng(
            geojson.getCoordinates()[i][j][1],
            geojson.getCoordinates()[i][j][0]
          );

          path.insertAt(path.getLength(), ll);
        }
        paths.insertAt(paths.getLength(), path);
      }

      opts.paths = paths;
      opts.fillColor = "#0000f2";
      opts.fillOpacity = 0.2;
      opts.strokeColor = "#fff";
      opts.strokeWeight = 5;
      opts.clickable = false;
      opts.editable = false;
      opts.zIndex = 1;

      return new google.maps.Polygon(opts);
    } else {
      return null;
    }
  }
  /* tslint:enable:prefer-for-of */

  private toggleFileUploadVisible() {
    this.closeGeojsonTextbox();
    this.isFileUploadVisible = !this.isFileUploadVisible;
    this.closeNearCarsInfo();
  }

  private renderMapFarm(farmMap: any) {
    this.$emit("renderMapFile", farmMap);
  }

  private showMapPointer() {
    if (this.drawingManager) {
      this.canClear = true;
      this.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.MARKER
      );

      this.closeGeojsonTextbox();
    }

    this.closeNearCarsInfo();
  }

  private async getFarmByCentroid(latLng: google.maps.LatLng) {
    const lat = latLng.lat();
    const lgn = latLng.lng();

    let response: CarDTO;

    try {
      response = (await carPointApi.findFarmByLatLong(lgn, lat)).data;
    } catch {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.search-by-lat-lng-error") as string
      );
      return;
    }

    if (response.ruralInfo.length == 0) {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.search-by-lat-lng-empty") as string
      );
      return;
    }

    this.drawingManager!.setDrawingMode(null);
    this.drawingManager!.setOptions({
      drawingControl: false,
    });
    this.canClear = true;

    if (response.ruralInfo.length > 1) {
      this.isCarSelectVisible = true;
      this.carResponseList = response.ruralInfo;
    } else {
      this.$emit("renderCarPoints", response.ruralInfo[0]);
    }
  }

  private closeCarSelectModal() {
    this.isCarSelectVisible = false;
  }

  private setCarSelected(carSelected: any) {
    this.carResponse = carSelected;
    this.$emit("renderCarPoints", this.carResponse);
  }

  private showCarModal() {
    this.closeGeojsonTextbox();
    this.$emit("showSearchCarModal");
    this.closeNearCarsInfo();
  }

  private closeNearCarsInfo() {
    this.carsNearInfo!.close();
  }

  private async showCarsNear() {
    // Pointer to map.
    const map = this.wrappedMap!;

    if (map && !this.toggleCarsNear){
      this.isLoading = true;
      // Getting centroid.
      const place = map.getCenter();
  
      // Getting near CAR's by map entroid.
      let cars: CarDTO;
      try {
        cars = (await carPointApi.findCarsNearByGeom(
          place.lng(), place.lat(),
        ))?.data;
      } catch {
        return;
      } finally {
        this.isLoading = false;
      }

      this.isLoading = false;

      const color = '#f4e006';
      const defaultStyle = {
        fillOpacity: 0.02,
        fillColor: color,
        strokeColor: color,
        strokeOpacity: 1,
        strokeWeight: 0.7,
      } as google.maps.Data.StyleOptions;

      this.carsNear = [];

      // For each CAR...
      cars.ruralInfo.forEach((car) => {
        // Wrapping Geometry coordinates on to features.
        const feature = wrapGeometryObject(car.geom, {
          color: '#92da1d',
          car: car.ruralCode,
        });
  
        // Pushing the feature in class property.
        this.carsNear.concat(map.data.addGeoJson(feature));
  
        // Applying styles on polygon line stroke.
        map.data.setStyle(() => defaultStyle);
      });

      // Adding mouse over to display InfoWindow.
      map.data.addListener('mouseover', (event) => {
        map.data.revertStyle();
        map.data.overrideStyle(event.feature, { strokeWeight: 2.7 });
      });

      // Adding mouse click to display InfoWindow.
      map.data.addListener('click', (event) => {
        this.carsNearInfo!.close();
        const carData = `<h2 style="font-weight: bold;text-align: center;">CAR</h2>
        <p style="margin: 0 auto;padding: 1em;">
          ${event.feature.getProperty('car')}
        </h2>`;
        this.carsNearInfo!.setContent(carData);
        this.carsNearInfo!.setPosition(event.latLng);
        this.carsNearInfo!.open(map);
      });

      // Adding mouseleave to remove InfoWindow.
      map.data.addListener('mouseleave', () => {
        map.data.revertStyle();
        this.carsNearInfo!.close();
      });

      this.toggleCarsNear = true;
    } else {
      this.removeCarsNear();
    }
  }

  private removeCarsNear() {
    const map = this.wrappedMap!;
    map.data.forEach((feature) => map.data.remove(feature));
    this.carsNear.length = 0;
    this.toggleCarsNear = false;
    this.carsNearInfo!.close();
  }
}
